module.exports = __webpack_public_path__ + "static/media/StrengtheningOurSocialSupportNetwork.0b95c85f.mp3";